import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@enlighten/design-system/dist/Button';
import Grid from '@enlighten/design-system/dist/Grid';
import Typography from '@enlighten/design-system/dist/Typography';
import Image from 'next/image';
import RtuImage from '../../assets/images/rtu/rtu-sec-01.png';
export default function RtuSection1({ type, onNewClick, onOtherClick, }) {
    return (_jsxs(Grid, { container: true, direction: "column", alignItems: "center", bgcolor: "#FFFAEF", width: "100%", children: [_jsx(Typography, { fontSize: { xs: 18, md: 22 }, fontWeight: 700, textAlign: "center", color: "common.black", marginTop: { xs: '60px', md: '80px' }, children: "\uBAA8\uB2C8\uD130\uB9C1\uBD80\uD130 \uBC1C\uC804\uC18C \uAD00\uB9AC\uAE4C\uC9C0!" }), _jsx(Typography, { fontSize: { xs: 34, md: 48 }, fontWeight: 700, textAlign: "center", color: "common.black", marginTop: "4px", children: '알아서 다~ 챙겨주는\n발전왕 모니터링(RTU)' }), type === 'home' && (_jsxs(Grid, { container: true, justifyContent: "center", gap: "12px", marginTop: { xs: 2, md: '20px' }, children: [_jsx(Button, { variant: "contained", onClick: onNewClick, sx: {
                            fontSize: 18,
                            bgcolor: '#0B74E2',
                            height: 60,
                            borderRadius: '6px',
                            padding: '16px 32px',
                            ':hover': {
                                bgcolor: '#0B74E2',
                            },
                        }, children: "\uC2E0\uADDC \uC2E0\uCCAD\uD558\uAE30" }), _jsx(Button, { variant: "contained", onClick: onOtherClick, sx: {
                            height: 60,
                            padding: '16px 32px',
                            borderRadius: '6px',
                            bgcolor: '#FFFFFF',
                            border: '1px solid #D6D7DA',
                            fontSize: 18,
                            color: '#1D1E1F',
                            ':hover': {
                                bgcolor: '#FFFFFF',
                            },
                        }, children: "\uAE30\uD0C0 \uBB38\uC758\uD558\uAE30" })] })), _jsx(Grid, { container: true, justifyContent: "center", paddingX: 3, sx: {
                    '& img': {
                        width: '100%',
                        maxWidth: { xs: '100%', md: 715 },
                        height: 'auto',
                    },
                }, children: _jsx(Image, { src: RtuImage, alt: "" }) })] }));
}
